// From: https://medium.com/@himanshuain5567/smoothly-scroll-a-selected-list-item-into-view-in-react-using-useref-hook-4bdb84932255
import { type PropsWithChildren, useEffect, useRef, type FC } from 'react';

interface Props extends PropsWithChildren {
  shouldScroll: boolean;
}

const ScrollIntoView: FC<Props> = ({ shouldScroll, children }) => {
  const listItemRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (shouldScroll && listItemRef.current) {
      listItemRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }, [shouldScroll]);
  // we can also keep the deps array empty so it will only run once on component mount
  return <div ref={listItemRef}>{children}</div>;
};

ScrollIntoView.displayName = 'ScrollIntoView';

export default ScrollIntoView;
